import { AfterViewInit, Component, ContentChild, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatColumnDef } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-exper-column',
  template: `
    <ng-container #somecont [matColumnDef]="name">
      <ng-container *ngIf="!noSort">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ labelDisplay }}</th>
      </ng-container>
      <ng-container *ngIf="noSort">
        <th mat-header-cell *matHeaderCellDef>{{ labelDisplay }}</th>
      </ng-container>
      <td mat-cell *matCellDef="let row">
        <ng-container *ngIf="tempnoname; else defaultCell">
          <small *ngIf="debug"><i>Template exists</i></small>
          <ng-template [ngTemplateOutlet]="tempnoname" [ngTemplateOutletContext]="{ $implicit: row }"></ng-template>
        </ng-container>
        <!-- <ng-container *ngIf="!temp">
          {{ row[this.name] }}
        </ng-container> -->
        <ng-template #defaultCell>
          <div *ngIf="debug">
            <small><i>Default view</i></small>
          </div>
          {{ row[this.name] }}
        </ng-template>
      </td>
    </ng-container>
  `,
  styles: [],
})
export class ExperColumnComponent implements OnInit, AfterViewInit {
  //@ContentChild(MatColumnDef) colDef: MatColumnDef;
  @Input() name!: string;
  @Input() label?: string;
  @Input() labelT?: string; // translation key
  @Input() noSort = false;
  @ViewChild(MatColumnDef) colDef: MatColumnDef;

  @Input() temp: TemplateRef<any>;
  @ContentChild('tempInside') tempInside: TemplateRef<any>;

  @ContentChild(TemplateRef) tempnoname: TemplateRef<any>;

  debug = false;

  constructor(private translate: TranslateService) {}

  get labelDisplay(): string {
    if (this.labelT) {
      return this.translate.instant(this.labelT);
    }
    if (this.label === '') {
      return '';
    }
    if (this.label) {
      return this.label;
    }
    return capitalize(this.name);
  }

  ngAfterViewInit(): void {
    // { [this.colDef.name]: this.noSort });
    // console.log(`Coldef: '${this.name}'`, this.colDef);
    // console.log(`ColdefViewChild: '${this.name}'`, this.colDef.name);
  }
  ngOnInit(): void {
    // console.log('temp', this.temp);
    // console.log('From column name', this.name);
  }
}

export function capitalize(input: string): string {
  if (!input) {
    return input;
  }
  return input.charAt(0).toUpperCase() + input.slice(1);
}
